// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/bundle." + "7c88d963e7eebc8a6f62" + ".min.js";
};